import { createSelector } from "@reduxjs/toolkit";
/**
 * Selector to get the entire app state.
 */
export const appStateSelector = createSelector(state => state.app, app => {
  return {
    isAlphaTestingEnabled: app.isAlphaTestingEnabled,
    isBetaTestingEnabled: app.isBetaTestingEnabled,
    isDevModeEnabled: app.isDevModeEnabled
  };
});